module.exports = __webpack_public_path__ + "public/img/xcs-3.0f3dfc0d.jpg";